import styled from '@emotion/styled'

export const DemsSidebarBackdrop = styled.div({
  position: 'fixed',
  top: 0,
  right: 0,
  left: 0, 
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', 
  zIndex: 999,
  transition: 'all .3s ease',
}, props => ({
  visibility: props.open ? 'visible' : 'hidden',
  opacity: props.open ? 1 : 0,
}))

export const DemsSidebar = styled.div({
  position: 'fixed',
  top: 0,
  // right: 0,
  bottom: 0,
  width: 500,
  maxWidth: '100%',
  backgroundColor: '#fff', 
  zIndex: 1000,
  boxShadow: '-4px 0 10px rgba(0,0,0,0.1)',
  borderTopLeftRadius: 20,
  borderBottomLeftRadius: 20,
  transition: 'all .3s ease',
}, props => ({
  right: props.open ? 0 : -550
}))


export const DemsSidebarHeader = styled.div({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0, 
  padding: '20px 24px',
  backgroundColor: '#fff', 
  zIndex: 10,
}, props => ({
}))

export const DemsSidebarTitle = styled.div({
  color: '#0A141E',
  fontWeight: 600,
  fontSize: 20,
  display: 'flex',
  alignItems: 'center',
  '& .title': {
    flex: 1
  }
}, props => ({
}))


export const DemsSidebarIcon = styled.div({
position: 'absolute',
top: 9,
right: 20,
}, props => ({
}))

export const DemsSidebarWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100% - 80px)',
  marginTop: 80,
  }, props => ({
  }))

export const DemsSidebarContent = styled.div({
padding: '0 24px 32px 34px',
flex: 1,
overflowY: 'auto',
}, props => ({
}))

export const DemsSingleContent = styled.div({
  backgroundColor: '#f5f5f5',
  borderRadius: 20
  }, props => ({
  }))

  export const DemsSingleRow = styled.div({
    borderBottom: '1px solid #e4e4e4',
    '&:last-child': {
      borderBottom: 'none',
      marginBottom: 12
    }
  })

  export const SingleDemCounter = styled.span({
    backgroundColor: '#fff',
    marginLeft: 4,
    display: 'inline-block',
    verticalAlign: 'middle',
    borderRadius: 20,
    padding: '2px 10px',
    fontWeight: 600,
    fontSize: 12
  })

export const DemsSidebarFooter = styled.div({
// position: 'absolute',
// bottom: 0,
// right: 0,
// left: 0,
display: 'flex',
padding: '10px 24px',
borderTop: '1px solid #DEDFE4',
}, props => ({
}))

export const DemSidebarCost = styled.span({
  flex:1,
  fontWeight: 600,
  fontSize: 17,
  '& span': {
    display: 'block',
    fontSize: 14,
    fontWeight: 500,
    opacity: '.5'
  }
})
